/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrderItemModel } from './OrderItemModel';
import {
    OrderItemModelFromJSON,
    OrderItemModelFromJSONTyped,
    OrderItemModelToJSON,
} from './OrderItemModel';

/**
 * 
 * @export
 * @interface PetPrescriptionLastOrderModel
 */
export interface PetPrescriptionLastOrderModel {
    /**
     * 
     * @type {number}
     * @memberof PetPrescriptionLastOrderModel
     */
    orderId?: number;
    /**
     * 
     * @type {string}
     * @memberof PetPrescriptionLastOrderModel
     */
    omsOrderStatus?: PetPrescriptionLastOrderModelOmsOrderStatusEnum;
    /**
     * 
     * @type {Array<OrderItemModel>}
     * @memberof PetPrescriptionLastOrderModel
     */
    orderItems?: Array<OrderItemModel>;
}


/**
 * @export
 */
export const PetPrescriptionLastOrderModelOmsOrderStatusEnum = {
    Backordered: 'BACKORDERED',
    Canceled: 'CANCELED',
    CsrEdit: 'CSR_EDIT',
    Deposited: 'DEPOSITED',
    NoInventory: 'NO_INVENTORY',
    PaymentInitiated: 'PAYMENT_INITIATED',
    PaymentRequiresReview: 'PAYMENT_REQUIRES_REVIEW',
    ReadyToRelease: 'READY_TO_RELEASE',
    Released: 'RELEASED',
    Shipped: 'SHIPPED',
    Submitted: 'SUBMITTED',
    SubmittedIncomplete: 'SUBMITTED_INCOMPLETE',
    Unknown: 'UNKNOWN'
} as const;
export type PetPrescriptionLastOrderModelOmsOrderStatusEnum = typeof PetPrescriptionLastOrderModelOmsOrderStatusEnum[keyof typeof PetPrescriptionLastOrderModelOmsOrderStatusEnum];


/**
 * Check if a given object implements the PetPrescriptionLastOrderModel interface.
 */
export function instanceOfPetPrescriptionLastOrderModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetPrescriptionLastOrderModelFromJSON(json: any): PetPrescriptionLastOrderModel {
    return PetPrescriptionLastOrderModelFromJSONTyped(json, false);
}

export function PetPrescriptionLastOrderModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetPrescriptionLastOrderModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderId': !exists(json, 'orderId') ? undefined : json['orderId'],
        'omsOrderStatus': !exists(json, 'omsOrderStatus') ? undefined : json['omsOrderStatus'],
        'orderItems': !exists(json, 'orderItems') ? undefined : ((json['orderItems'] as Array<any>).map(OrderItemModelFromJSON)),
    };
}

export function PetPrescriptionLastOrderModelToJSON(value?: PetPrescriptionLastOrderModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderId': value.orderId,
        'omsOrderStatus': value.omsOrderStatus,
        'orderItems': value.orderItems === undefined ? undefined : ((value.orderItems as Array<any>).map(OrderItemModelToJSON)),
    };
}

